const STORAGE_KEY = "cs_prefs";

export const DEFAULT_PREFS = {
  theme: "dark",
  audioLang: "es",
  subtitleLang: "off",
  iptvRegion: "",
  iptvKind: "",
};

export function loadPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return {
      theme: parsed.theme === "light" ? "light" : "dark",
      audioLang: typeof parsed.audioLang === "string" ? parsed.audioLang : DEFAULT_PREFS.audioLang,
      subtitleLang:
        typeof parsed.subtitleLang === "string" ? parsed.subtitleLang : DEFAULT_PREFS.subtitleLang,
      iptvRegion: typeof parsed.iptvRegion === "string" ? parsed.iptvRegion : DEFAULT_PREFS.iptvRegion,
      iptvKind: typeof parsed.iptvKind === "string" ? parsed.iptvKind : DEFAULT_PREFS.iptvKind,
    };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function savePrefs(partial) {
  const next = { ...loadPrefs(), ...partial };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  applyTheme(next.theme);
  return next;
}

export function applyTheme(theme) {
  const mode = theme === "light" ? "light" : "dark";
  document.documentElement.setAttribute("data-theme", mode);
  try {
    document.body.style.colorScheme = mode;
  } catch {
    /* ignore */
  }
}

export function langMatches(haystack, want) {
  const a = String(haystack || "")
    .toLowerCase()
    .trim();
  const b = String(want || "")
    .toLowerCase()
    .trim();
  if (!a || !b) return false;
  if (a === b) return true;
  if (a.startsWith(b) || b.startsWith(a)) return true;
  const aliases = {
    es: ["spa", "spanish", "español", "espanol", "castellano"],
    en: ["eng", "english", "inglés", "ingles"],
    pt: ["por", "portuguese", "portugués", "portugues"],
    ja: ["jpn", "japanese", "japonés", "japones"],
  };
  const list = aliases[b] || [];
  return list.some((x) => a === x || a.includes(x) || a.startsWith(x));
}

applyTheme(loadPrefs().theme);
